import React, { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';
import './SafeImage.css';

// Drop-in replacement for <img> — a missing `src`, or one that 404s/fails to
// load, renders a muted placeholder box (same size/shape as the image would
// have been, via the same style/className) instead of the browser's broken
// image icon. Callers can provide a custom fallback when the surrounding UI
// has a more useful empty state, such as a member's initial. Any other <img>
// prop (alt, onClick, etc.) passes through.
const SafeImage = ({ src, alt = '', style, className = '', iconSize = 18, fallback = null, ...rest }) => {
    const [failed, setFailed] = useState(false);

    // A new src (e.g. list item reused a component instance) deserves a
    // fresh attempt rather than staying stuck on a previous failure.
    useEffect(() => { setFailed(false); }, [src]);

    if (!src || failed) {
        if (fallback !== null) return fallback;

        return (
            <div
                className={`safe-image-fallback ${className}`}
                style={style}
                role="img"
                aria-label={alt || 'Image unavailable'}
                title={alt || 'Image unavailable'}
            >
                <ImageOff size={iconSize} />
            </div>
        );
    }

    return (
        <img
            src={src}
            alt={alt}
            style={style}
            className={className}
            onError={() => setFailed(true)}
            {...rest}
        />
    );
};

export default SafeImage;
